import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone, MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';

const FinalCTASection = () => {
  const scrollToContact = () => {
    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="final-cta"
      className="relative py-24 md:py-32 overflow-hidden bg-slate-50"
      data-testid="final-cta-section"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-primary/5 rounded-full blur-2xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2
            className="font-oswald text-3xl md:text-4xl lg:text-5xl font-bold text-slate-800 uppercase tracking-tight mb-6"
            data-testid="final-cta-headline"
          >
            Ready to Discuss Your{' '}
            <span className="text-accent">Requirements?</span>
          </h2>
          <p className="font-manrope text-lg md:text-xl text-slate-600 max-w-2xl mx-auto mb-10">
            Let's explore how we can support your facility management needs with a tailored, long-term solution.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Button
            onClick={scrollToContact}
            size="lg"
            className="bg-accent hover:bg-accent-hover text-white font-manrope font-bold text-base px-10 py-6 rounded-sm btn-glow"
            data-testid="final-cta-quote-btn"
          >
            <MessageSquare className="w-5 h-5 mr-2" />
            Request a Proposal
          </Button>
          <Button
            onClick={scrollToContact}
            size="lg"
            className="bg-primary hover:bg-primary-dark text-white font-manrope font-bold text-base px-10 py-6 rounded-sm"
            data-testid="final-cta-speak-btn"
          >
            <Phone className="w-5 h-5 mr-2" />
            Schedule a Consultation
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;
